<template>
  <unicom-layout-cartao semFiltro>
    <unicom-linha class="linha-embaixo">
      <unicom-coluna sm="12" style="padding-bottom: 24px">
        <div class="titulo negrito cor-fonte fonte-primaria">Serviços</div>
      </unicom-coluna>
    </unicom-linha>

    <pronto-atendimento-componente
      v-if="objetoServicos['Pronto Atendimento'].ativo"
      :dadosServidor="this.dadosServidor"
      :servico="objetoServicos['Pronto Atendimento']"
      @colher-payload="prepararPayloadServicos"
      @switch="switchHandler"
    ></pronto-atendimento-componente>

    <laboratorio-componente
      v-if="objetoServicos['Laboratório'].ativo"
      :dadosServidor="this.dadosServidor"
      :servico="objetoServicos['Laboratório']"
      @colher-payload="prepararPayloadServicos"
      @switch="switchHandler"
    ></laboratorio-componente>

    <centro-diagnostico-componente
      v-if="objetoServicos['Centro de Diagnóstico'].ativo"
      :dadosServidor="this.dadosServidor"
      :servico="objetoServicos['Centro de Diagnóstico']"
      @colher-payload="prepararPayloadServicos"
      @switch="switchHandler"
    ></centro-diagnostico-componente>

    <posto-coleta-componente
      v-if="objetoServicos['Posto de Coleta'].ativo"
      :dadosServidor="this.dadosServidor"
      :servico="objetoServicos['Posto de Coleta']"
      @colher-payload="prepararPayloadServicos"
      @switch="switchHandler"
    ></posto-coleta-componente>
  </unicom-layout-cartao>
</template>

<script>
import ServicosMixin from "./ServicosMixin";

import LaboratorioComponente from "./components/LaboratorioComponente.vue";
import CentroDiagnosticoComponente from "./components/CentroDiagnosticoComponente.vue";
import ProntoAtendimentoComponente from "./components/ProntoAtendimentoComponente.vue";
import PostoColetaComponente from "./components/PostoColetaComponente.vue";

export default {
  mixins: [ServicosMixin],
  components: {
    LaboratorioComponente,
    CentroDiagnosticoComponente,
    ProntoAtendimentoComponente,
    PostoColetaComponente
  },
  data() {
    return {};
  },
  methods: {
    prepararPayloadServicos(payloadDoComponente) {
      if (!payloadDoComponente) return;

      this.objetoServicos[payloadDoComponente.tipoServico].payload = {
        ...payloadDoComponente
      };

      if (payloadDoComponente.clickSwitch) {
        this.objetoServicos[payloadDoComponente.tipoServico].preenchido = true;
      }

      this.preparaDadosServicos();
    },
    switchHandler(payload) {
      this.objetoServicos[payload.tipoServico].preenchido = payload.clickSwitch;

      if (!payload.clickSwitch) {
        this.payloadServicos = this.payloadServicos.filter(
          servico => servico.tipoServico.tipoServico !== payload.tipoServico
        );
        this.payloadEspecialidades = this.payloadEspecialidades.filter(
          espe => espe.tipoServico.tipoServico !== payload.tipoServico
        );
        this.payloadAbrancencias = this.payloadAbrancencias.filter(
          abran => abran.tipoServico.tipoServico !== payload.tipoServico
        );
      }
      this.$emit("payload-atualizado", {
        servicos: [...this.payloadServicos],
        especialidades: [...this.payloadEspecialidades],
        abrangencias: this.payloadAbrancencias
      });
    }
  }
};
</script>

<style scoped>
.linha-embaixo {
  padding-bottom: 24px;
  border-bottom: 1px solid #ebebeb;
  margin-bottom: 24px;
}
</style>
